import { Component, OnInit } from '@angular/core';

import { EventType } from '../../../../../../models/event-type';
import { EventTypeStatus, EventTypeWaitlistScope } from '../../../../../../models/event-type-enums';
import { EventTypeService } from '../../../../../../services/event-type/event-type.service';


@Component({
  selector: 'app-event-type-waitlists',
  templateUrl: './event-type-waitlists.component.html',
  styleUrls: ['./event-type-waitlists.component.css']
})
export class EventTypeWaitlistsComponent implements OnInit {
  public status: EventTypeStatus = EventTypeStatus.active;
  public eventTypes: EventType[];
  public waitlistCounts: {[key: number]: number};

  public loadingEventTypes = true;
  public loadingWaitlistCounts = true;

  public serverError: number = null;

  public readonly EventTypeStatus = EventTypeStatus;

  constructor(
    private eventTypeService: EventTypeService,
  ) {}

  ngOnInit() {
    this.loadEventTypes();
  }

  public loadEventTypes() {
    this.loadingEventTypes = true;

    this.eventTypeService
      .getEventTypes(
        1,
        3000,
        {
          status: this.status,
          waitlist_scope: EventTypeWaitlistScope.eventType
        }
      )
      .then(response => {
        this.eventTypes = response.results;
        this.loadWaitlistCounts();
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingEventTypes = false; });
  }

  public loadWaitlistCounts() {
    this.loadingWaitlistCounts = true;

    this.eventTypeService
      .getEventTypeWaitlistCounts(
        this.eventTypes.map(et => et.id)
      )
      .then(response => {
        this.waitlistCounts = response;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingWaitlistCounts = false; });
  }
}
